<template>
  <div>
    <el-form :inline="true" :model="params" class="demo-form-inline">
      <el-form-item label="姓名">
        <el-input
          size="small"
          v-model="params.persionName"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input
          size="small"
          v-model="params.phonenumber"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="danger" size="small" @click="getTeacherList"
          >查询</el-button
        >
        <el-button size="small" @click="onReset">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- @current-change="clickChange" -->
    <el-table
      v-loading="loading"
      :data="data"
      row-key="userId"
      style="width: 100%; margin-top: 20px"
      :row-class-name="tableRowClassName"
      @current-change="clickChange"
    >
      <el-table-column label width="35">
        <template slot-scope="scope">
          <el-radio :label="scope.row" v-model="tableRadio">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column prop="templateName" label="头像">
        <template slot-scope="scope">
          <el-avatar
            size="medium"
            :src="
              scope.row.avatar ||
              'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
            "
          ></el-avatar>
        </template>
      </el-table-column>
      <el-table-column prop="persionName" label="姓名"> </el-table-column>
      <el-table-column prop="phonenumber" label="手机号"> </el-table-column>
    </el-table>
    <div class="se-flex-h-c se-m-t-20">
      <el-pagination
        background
        @current-change="currentChange"
        :current-page="currentPage"
        :page-size="params.pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    teaType: {
      type: Number,
      default: null,
    },
    planUserIds: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      params: {
        lastPage: 0,
        pageNum: 1,
        pageSize: 10,
        persionName: "",
        phonenumber: "",
        status: null,
        // deptId: null,
        teacherType: null,
      },
      loading: false,
      data: [],
      total: 0,
      currentPage: 1,
      selectTeaList: [],
      tableRadio: null,
    };
  },

  created() {
    this.params.teacherType = this.teaType;
    // if (this.planUserIds) {
    //   this.tableRadio = this.planUserIds;
    // }
    this.getTeacherList();
  },

  methods: {
    //   获取人员列表
    async getTeacherList() {
      this.loading = true;
      const res = await this.$http.get(
        "/server/system/user/getUserList",
        this.params
      );
      this.data = res.rows;
      this.total = res.total;
      this.loading = false;
    },

    //  重置
    onReset() {
      this.params = {
        lastPage: 0,
        pageNum: 1,
        pageSize: 10,
        persionName: "",
        phonenumber: "",
        status: null,
        teacherType: null,
      };
      this.getTeacherList();
    },

    // 分页回调
    currentChange(val) {
      this.params.pageNum = val;
      this.getTeacherList();
    },

    clickChange(item) {
      console.log(item, "item");
      this.tableRadio = item;
    },

    tableRowClassName({ row, rowIndex }) {
      // console.log(row, "row");
      // console.log(rowIndex, "rowIndex");
      // row.index = rowIndex; //在原有的数据上加一个index
    },

    // 确认
    confirm() {
      this.$emit("sendTeacher", this.tableRadio);
    },
  },
};
</script>

<style lang="scss" scoped></style>
